import { useNavigate } from 'react-router-dom';

export default function ProductCategories() {
  const navigate = useNavigate();

  const categories = [
    {
      title: 'Tile Adhesive',
      description: 'High-bond formulas for floor and wall tiles. Available in Everyday, Contractor Grade, and Elite Pro.',
      icon: 'ri-layout-grid-line',
      color: '#4CAF50',
      path: '/products/tile-adhesive',
    },
    {
      title: 'Grout',
      description: 'Durable, stain-resistant grout in multiple colours. Three tiers to match your project needs.',
      icon: 'ri-grid-line',
      color: '#F2C612',
      path: '/products/grout',
    },
    {
      title: 'Paint & Coatings',
      description: 'Premium interior and exterior paints. Long-lasting coverage with superior finish.',
      icon: 'ri-brush-line',
      color: '#FF9800',
      path: '/products/paint',
    },
    {
      title: 'Bonding Liquid',
      description: 'Enhance adhesion for tiles, renders, and screeds. Professional-grade bonding agent.',
      icon: 'ri-drop-line',
      color: '#2196F3',
      path: '/products',
    },
  ];

  return (
    <section id="product-categories" className="w-full bg-[#F8F8F8] py-16 md:py-24 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2
            className="text-[32px] md:text-[48px] font-bold text-[#1A1A1A] mb-4 md:mb-6"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Our Product Range
          </h2>
          <p
            className="text-[16px] md:text-[18px] text-[#666666] max-w-3xl mx-auto"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            From tile adhesive to paint, every product is available in three performance tiers
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {categories.map((category, index) => (
            index === 0 ? (
              <div
                key={index}
                className="relative rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group min-h-[260px] md:min-h-[300px]"
                onClick={() => navigate(category.path)}
              >
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: "url('https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/74a8b693dc928470610048903c6ca3f4.png')" }}
                />
                <div className="absolute inset-0 bg-black/50" />
                <div className="relative z-10 p-6 md:p-8 flex flex-col justify-end h-full">
                  <h3
                    className="text-[22px] md:text-[26px] font-bold text-white mb-3 md:mb-4"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {category.title}
                  </h3>
                  <p
                    className="text-[14px] md:text-[16px] text-white/90 leading-relaxed mb-4 md:mb-6"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {category.description}
                  </p>
                  <div className="flex items-center text-white font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                    <span className="text-[14px] md:text-[15px]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Learn More
                    </span>
                    <i className="ri-arrow-right-line text-[18px] md:text-[20px]"></i>
                  </div>
                </div>
              </div>
            ) : index === 1 ? (
              <div
                key={index}
                className="relative rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group min-h-[260px] md:min-h-[300px]"
                onClick={() => navigate(category.path)}
              >
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: "url('https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/e2e1cb1e446df8d5de915281889bcb54.png')" }}
                />
                <div className="absolute inset-0 bg-black/50" />
                <div className="relative z-10 p-6 md:p-8 flex flex-col justify-end h-full">
                  <h3
                    className="text-[22px] md:text-[26px] font-bold text-white mb-3 md:mb-4"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {category.title}
                  </h3>
                  <p
                    className="text-[14px] md:text-[16px] text-white/90 leading-relaxed mb-4 md:mb-6"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {category.description}
                  </p>
                  <div className="flex items-center text-white font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                    <span className="text-[14px] md:text-[15px]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Learn More
                    </span>
                    <i className="ri-arrow-right-line text-[18px] md:text-[20px]"></i>
                  </div>
                </div>
              </div>
            ) : index === 2 ? (
              <div
                key={index}
                className="relative rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group min-h-[260px] md:min-h-[300px]"
                onClick={() => navigate(category.path)}
              >
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: "url('https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/65ad714713375d898c35137567a89d53.png')" }}
                />
                <div className="absolute inset-0 bg-black/50" />
                <div className="relative z-10 p-6 md:p-8 flex flex-col justify-end h-full">
                  <h3
                    className="text-[22px] md:text-[26px] font-bold text-white mb-3 md:mb-4"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {category.title}
                  </h3>
                  <p
                    className="text-[14px] md:text-[16px] text-white/90 leading-relaxed mb-4 md:mb-6"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {category.description}
                  </p>
                  <div className="flex items-center text-white font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                    <span className="text-[14px] md:text-[15px]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Learn More
                    </span>
                    <i className="ri-arrow-right-line text-[18px] md:text-[20px]"></i>
                  </div>
                </div>
              </div>
            ) : (
              <div
                key={index}
                className="relative rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group min-h-[260px] md:min-h-[300px]"
                onClick={() => navigate(category.path)}
              >
                <div
                  className="absolute inset-0 bg-cover bg-center"
                  style={{ backgroundImage: "url('https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/49a63c17bb5171112618e585f480fb26.png')" }}
                />
                <div className="absolute inset-0 bg-black/50" />
                <div className="relative z-10 p-6 md:p-8 flex flex-col justify-end h-full">
                  <h3
                    className="text-[22px] md:text-[26px] font-bold text-white mb-3 md:mb-4"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {category.title}
                  </h3>
                  <p
                    className="text-[14px] md:text-[16px] text-white/90 leading-relaxed mb-4 md:mb-6"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {category.description}
                  </p>
                  <div className="flex items-center text-white font-semibold group-hover:gap-3 gap-2 transition-all duration-300">
                    <span className="text-[14px] md:text-[15px]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      Learn More
                    </span>
                    <i className="ri-arrow-right-line text-[18px] md:text-[20px]"></i>
                  </div>
                </div>
              </div>
            )
          ))}
        </div>
      </div>
    </section>
  );
}